import useSWR from "swr";
import { getRoutines } from "../services/template-service";
import type { RoutinesResponse, RoutineItem } from "../types/api-types";

export interface UseRoutinesReturn {
  routines: RoutineItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useRoutines = (templateId: number | null): UseRoutinesReturn => {
  const { data, error, isLoading, mutate } = useSWR<RoutinesResponse>(
    templateId ? `routines-${templateId}` : null,
    () =>
      templateId ? getRoutines(templateId) : Promise.resolve({ results: [] }),
  );

  return {
    routines: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useRoutines;
